<template>
    <div class="viz-wrapper">
      <div class="col-xs-12" v-if="isLoading">
          <div class="text-center vertical-center h-100">
              <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
          </div>
      </div>
      <div v-else-if="renderData && renderData.series && renderData.series.length == 0" class="text-center vertical-center h-100 no-data-banner">
          <span>No data</span>
      </div>
      <template v-else>
          <ls-chart target-css-classes="chart" v-if="renderData && renderData.type == 'chart'"
                    v-bind:height="height"
                    v-bind:width="width"
                    v-bind:target-id="chartId"
                    v-bind:bc-data="renderData.series"
                    v-bind:bc-layout="renderData.layout">
          </ls-chart>
          <ls-metric-banner v-else-if="renderData && renderData.type == 'banner'"
                            v-bind:series="renderData.series">
          </ls-metric-banner>
          <ls-table v-else-if="renderData && renderData.type == 'table'" v-bind:table-data="renderData.series" v-bind:table-layout="renderData.layout"></ls-table>
          <div v-else-if="!isLoading" class="text-error text-center vertical-center h-100">
              <i class="fa fa-frown-o fa-3x fa-fw" aria-hidden="true"></i>
              <br>
              <span class="fa-1x">Sorry! Something went wrong. Please, try again later.</span>
          </div>
      </template>
    </div>
</template>

<script>
 import Vue from 'vue';

 import LsChart from 'components/elements/PlotlyJS/LSBasicChart';
 import LsTable from 'components/elements/LsTable';
 import LsMetricBanner from 'components/elements/LsMetricBanner';

 // Load the full build. 
 var _ = require('lodash');

 export default {
     components: {
         LsChart,
         LsTable,
         LsMetricBanner
     },
     props: {
         isLoading: Boolean,
         chartId: String,
         renderData: {
             type: Object,
             default() {
                 return {
                     type: null,
                     series: [],
                     layout: null
                 };
             }
         },
         height: {
             type: Number
         },
         width: {
             type: Number
         },
     }
 };
</script>


<style lang="scss" scoped>
 @import "./static/css/_variables.scss";
 
 .viz-wrapper {
     flex: 1;
     align-items: stretch;
     justify-content: stretch;
     padding: 0;
     display: flex;
     height: 100%;
     width: 100%;
 }

 .no-data-banner {
     height: 100%;
     display: flex;
     flex-direction: column;
     justify-content: center;
     flex: 1;
 }
 
 .no-data-banner span {
     color: #444;
     font-size: 1rem;
     margin-top: -1rem;
     font-family: "Roboto Mono", "Inconsolata", monospace;
     display: inline-block;
 }

 .no-data-banner span::before,
 .no-data-banner span::after {
     content: " - ";
 }
</style>



// WEBPACK FOOTER //
// VizWidget.vue?95534782